<template>
    <v-content class="pushlist">
        <SelectedShop v-if="init.branch_flg == 1" :selected_shop_name="selected_shop" :router_param="{ name: 'notification_shops', query: { feature_id: 'notification_list'}}" ></SelectedShop>
        <div class="pa-3">

            <div v-for="(item, index) in this.data" :key="item.id" @click.stop="onClickBtn(item.link)">
                <!-- 固定通知 -->
                <div class="fixedPush py-2 px-4" v-if="item.fixed_flg" @click="detail(item)">
                    {{item.title}}<v-icon color="#9D9D9D">mdi-chevron-right</v-icon>
                </div>

                <div v-if="index == 0 || item.push_date != data[index-1].push_date" class="monthbar"><span>{{item.push_date}}</span></div>
                <Row v-if="!item.fixed_flg" :item="item" :router_param="{ name: 'notification_detail', query: {
                  id: item.id,
                  contents_type: item.contents_type,
                  create_date: item.create_date,
                  push_date: item.push_date,
                  shop_name: item.shop_name,
                  shop_id: init.shop_id
                }}" >
                </Row>
            </div>

            <!-- InfiniteLoading -->
            <infinite-loading ref="infiniteLoading"  @infinite="infiniteHandler" spinner="spiral">
              <div slot="spinner"><v-progress-circular :size="30" :width="2" class="maincolor" indeterminate></v-progress-circular></div>
              <div slot="no-more"></div>
              <!-- 20201124 NEW_DEV-734 cyber 段 start -->
              <div slot="no-results">現在、メッセージはありません</div>
              <!-- 20201124 NEW_DEV-734 cyber 段 end -->
            </infinite-loading>

        </div>
    </v-content>
</template>

<script>
import SelectedShop from '@/components/selected_shop.vue'
import Row from '@/views/notification/row.vue'
import InfiniteLoading from 'vue-infinite-loading';
export default {
    components: {
        SelectedShop,
        InfiniteLoading,
        Row
    },
    data: () => ({
        data: [],
        result: [],
        page: 1,
        selected_shop: '全て',
    }),
    methods: {
        onClickBtn(link) {
            this.$router.push(link)
        },
        async infiniteHandler() {

            this.init = this.storageGet('*')

            var shop_id = this.getUrlGetParam('shop_id');
            var selected_shop = this.getUrlGetParam('selected_shop');

            if (selected_shop) {
                this.selected_shop = selected_shop
            } else {
                this.selected_shop = '全て'
            }

            var params = {
                'sid': this.init.sid,
                'device_uid': this.init.device_uid,
                'device_id': this.init.device_id,
                'os': this.init.os,
                'key': this.init.key,
                'location': 0,
                'feature_id': this.init.feature_id,
                'page': this.page
            }

            if (shop_id) {
                params['shop_id'] = shop_id
            }

            var shoplist_req = { params: params }

            var res = await this.apiCall('/user/notifications', shoplist_req)
            if (this.page == 1) {
                this.$set(this, 'result', res)
                this.$set(this, 'data', res.data)
            } else {
                this.data = this.data.concat(res.data);
            }

            this.page = this.page + 1

            if (res.data && res.data.length > 0) {
                this.$refs.infiniteLoading.stateChanger.loaded()
            } else {
                this.$refs.infiniteLoading.stateChanger.complete()
            }

        },
        async detail(item) {
          // push既読処理
          var res = null;
          this.init = this.storageGet('*')
          var params = { params: {
            'sid': this.init.sid,
            'service_cd': this.init.service_cd,
            'device_uid': this.init.device_uid,
            'device_id': this.init.device_id,
            'os': this.init.os,
            'key': this.init.key,
            'id': item.id,
          }};
          if (item.contents_type == 1) {// お知らせ
              res = await this.apiCall('/user/notification/detail', params, 'get');
              if (!res) return false;
              this.routerBindTo({name: 'notification_detail', query: {
                id: item.content_id,
                // NEW_DEV-1437 cyber start
                push_id: item.id,
                contents_type: item.contents_type,
                create_date: item.create_date,
                shop_name: item.shop_name,
                push_date: item.push_date
              }});
          } else if (item.contents_type == 2) { // クーポン
              res = await this.apiCall('/user/notification/detail', params, 'get');
              if (!res) return false;
              this.routerBindTo({name: 'coupon_detail', query: { id: item.content_id, push_id: item.id, create_date: item.push_date}});
          } else {
            this.routerBindTo({name: 'notification_detail', query: {
              id: item.id,
              push_id: item.id,
              // NEW_DEV-1437 cyber end
              contents_type: item.contents_type,
              create_date: item.create_date,
              push_date: item.push_date,
              shop_name: item.shop_name
            }});
          }
        }
    },
    created() {
      this.getUrlParam()
      this.init = this.storageGet('*')
      this.selected_shop = this.init.selected_shop
    },
}
</script>

<style scoped>
.rounded {
    border-radius: 10px;
}
.viewflg_label {
    position: absolute;
    left: 5px;
    bottom: 5px;
}
.fixedPush {
  filter: drop-shadow(0 0 10px #00000033);
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 15px;
}
.fixedPush .v-icon {
  color: #FF5256 !important;
}
</style>
